import { symbol } from "./symbol.js";
<ebay-icon ...input _name="heart-20" _size="20" _type="icon" _themes=symbol/>